module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.quest) ? _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin": "1rem"
    }
  }, [_c('h3', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.quest.name))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.hasNoReqs) ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("This quest has no skill or quest requirements!")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns has-text-left"
  }, [(_vm.minSkills) ? _c('div', {
    staticClass: "column is-one-third"
  }, [_c('h3', {
    staticClass: "subtitle is-4"
  }, [_vm._v("Skills")]), _vm._v(" "), _vm._l((_vm.minSkills), function(level, skill) {
    return _c('li', [_vm._v("\n        " + _vm._s(_vm.title(skill)) + ": " + _vm._s(level) + "\n      ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.preReqs.length > 0) ? _c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "subtitle is-4"
  }, [_vm._v("Pre-Requisites")]), _vm._v(" "), _vm._l((_vm.preReqs), function(preReq) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Quest',
          params: {
            slug: preReq.slug
          }
        }
      }
    }, [_vm._v("\n          " + _vm._s(preReq.name) + "\n        ")]), _vm._v("\n        ("), _c('a', {
      on: {
        "click": function($event) {
          _vm.$emit('nav', preReq.slug)
        }
      }
    }, [_vm._v("preview")]), _vm._v(")\n      ")], 1)
  })], 2) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0516b49a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quest.vue
// module id = 135
// module chunks = 1